import {reduceValueKeys} from '@shared/helpers/object'

import makeSlice from '@web/slices/orderTotal/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload}) => {
            const {data} = payload
            state.amount = data.totalOrderAmount

            state.deliveryFeeAmount = data.totalDeliveryFeeAmount

            state.discountAmount = data.totalDiscountAmount

            state.deliveryDiscountAmount = reduceValueKeys(
                (acc, deliveryGroup) => {
                    return acc + (deliveryGroup.deliveryFeeDiscountAmount ?? 0)
                },
                0,
                data.delivery.deliveryGroupsByKey,
            )

            state.productDiscountAmount = data.totalProductDiscountAmount
        })
    },
})

export default slice.reducer
